

import MainStore from "../store/MainStore";
import * as olProj from "ol/proj";
import MapLayerServices from "./MapLayerServices";
import moment from "moment";
import UserAnnexesService from "./UserAnnexesService";


class FormsService{

    constructor() {
        this.mapLayersServices = new MapLayerServices();
    }

    exportOptions(){
        return(
            {
                filter: function (element) {
                    var className = element.className || '';
                    return (
                        className.indexOf('ol-control') === -1 ||
                        className.indexOf('ol-scale') > -1 ||
                        (className.indexOf('ol-attribution') > -1 &&
                            className.indexOf('ol-uncollapsible'))
                    );
                },
            })
    };

    prepareMap(refMap){

        let mapLayers = refMap.getLayers().getArray()
        mapLayers.map((layer,index)=>{
           (index>2)?layer.setVisible(false):null;
        })
        let vectorLayers = mapLayers.filter(layer => layer.get('name') === 'geomlayer')
        vectorLayers[0].setZIndex(1000);
        let vectorSource = (vectorLayers && vectorLayers[0])?vectorLayers[0].getSource():null;
        (vectorLayers && vectorLayers[0])?vectorLayers[0].setVisible(true):null;
        (vectorSource)?refMap.getView().fit(vectorSource.getExtent(),{maxZoom: 19}, refMap.getSize()):null;

        const expectedResolution = refMap.getView().getResolution();
        const units = refMap.getView().getProjection().getUnits();
        const zoom = refMap.getView().getZoom()

        return expectedResolution + 0.5
    }

    showLayers(layerRefs, refMap){
        this.mapLayersServices.addLayer(refMap,layerRefs);
    }

    prepareMapProForms(refMap) {
        // Get all layers (flattening groups)
        const flatLayers = this.flattenLayers(refMap.getLayers().getArray());
        
        flatLayers.forEach(layer => {
            if (layer.get('name')!=='IGN' && layer.get('name')!=='cadastre:parcelles'){
                layer.setVisible(false);
            }
        });
      
        // Then specifically set the geom layer's z-index to 10000
        const geomLayer = flatLayers.find(layer => layer.get('name') === 'geomlayer');
        if (geomLayer) {
          geomLayer.setVisible(true);
          geomLayer.setZIndex(10000);
      
          const vectorSource = geomLayer.getSource();
          if (vectorSource) {
            console.log("Geom Layer:", geomLayer);
            refMap.getView().fit(vectorSource.getExtent(), { maxZoom: 17 }, refMap.getSize());
          }
        }
      
        // Optionally force a re-render
        refMap.renderSync();
      
        return refMap.getView().getResolution() + 0.5;
      }
      

    // Recursive function to get all individual layers
    flattenLayers(layersArray) {
        let flatLayers = [];
        layersArray.forEach(layer => {
            if (layer.getLayers) { // This is a LayerGroup
                flatLayers = flatLayers.concat(this.flattenLayers(layer.getLayers().getArray()));
            } else {
                flatLayers.push(layer);
            }
        });
        return flatLayers;
    };

    storeScreenCapturesAsDocItems(screensRef, refFormType = null, stamp = null) {

        const refMap = $('#map').data('map');
        const that = this;

        return new Promise((resolve, reject)=>{
            //console.log(screensRef[0].layers)
            that.captureScreenLocation(refMap, 72, 3, screensRef).then((captResult)=>{
                //console.log(captResult)
                resolve(captResult)
            })
        }).catch(err => console.log('Erreur de capture:' + err));
    }

    captureScreenLocation(refMap2, resolution=150, scale=3, layers=null){
        //a4: [297, 210],
        //a5: [210, 148],
        const refMap = $('#map').data('map');
        let mapLayers = refMap.getLayers().getArray() // stock all layers for after

        resolution = 72
        scale = this.prepareMap(refMap);
        (layers)?this.showLayers(layers,refMap):null;

        const dim = [620, 320]
        const width = Math.round((dim[0] * resolution) / 25.4);
        const height = Math.round((dim[1] * resolution) / 25.4);

        let size = refMap.getSize();

        let viewResolution = refMap.getView().getResolution();
        let scaleResolution = scale / olProj.getPointResolution(refMap.getView().getProjection(), resolution / 25.4, refMap.getView().getCenter());

        let promise = new Promise((resolve, reject)=>{
            refMap.once('rendercomplete', (event)=>{
                let canvas = event.context.canvas;
                let srcData = canvas.toDataURL('image/jpeg');
                refMap.setSize(size);
                refMap.getView().setResolution(viewResolution);
                mapLayers.map((layer,index)=>{ layer.setVisible(true)})
                resolve(srcData)
            })
            refMap.render()
        })

        let printSize = [width, height];
        refMap.setSize(printSize);
        refMap.getView().setResolution(scaleResolution);
        refMap.renderSync();
        return promise

    }

    captureScreenLocationProForms(refMap, resolution = 150, scale = 1, layers = null) {
        // Force specific resolution and prepare the map
        resolution = 72;
        // prepareMapProForms already centers the view on the vector layer (if available)
        scale = this.prepareMapProForms(refMap);
        if (layers) {
          this.showLayers(layers, refMap);
        }
      
        // Define desired print dimensions (in mm) and calculate pixel dimensions
        const dim = [620, 320];
        const width = Math.round((dim[0] * resolution) / 25.4);
        const height = Math.round((dim[1] * resolution) / 25.4);
      
        // Save the original map size and resolution to restore later
        const originalSize = refMap.getSize();
        const originalResolution = refMap.getView().getResolution();
      
        // Flatten the layers and adjust visibility: keep only 'IGN', 'cadastre:parcelles', and 'geomlayer'
        const mapLayers = this.flattenLayers(refMap.getLayers().getArray());
        mapLayers.forEach(layer => {
          if (
            layer.get('name') !== 'IGN' &&
            layer.get('name') !== 'cadastre:parcelles' &&
            layer.get('name') !== 'geomlayer'
          ) {
            layer.setVisible(false);
          } else {
            console.log("Layer visible:", layer.get('name'));
          }
        });
        console.log("Flattened Layers:", mapLayers);
      
        // Calculate the new resolution for printing
        let scaleResolution = scale / olProj.getPointResolution(
          refMap.getView().getProjection(),
          resolution / 25.4,
          refMap.getView().getCenter()
        );
      
        // Create a promise that resolves with the image data once rendering is complete
        const promise = new Promise((resolve, reject) => {
          refMap.once('rendercomplete', () => {
            // Get all canvas elements rendered by the map
            const canvasElements = refMap.getViewport().querySelectorAll('canvas');
            if (!canvasElements || canvasElements.length === 0) {
              reject(new Error("No canvas elements found"));
              return;
            }
            let srcData;
            if (canvasElements.length === 1) {
              // Only one canvas; use it directly
              srcData = canvasElements[0].toDataURL('image/jpeg');
            } else {
              // Merge multiple canvases into one offscreen canvas
              const mergedCanvas = document.createElement('canvas');
              mergedCanvas.width = width;
              mergedCanvas.height = height;
              const context = mergedCanvas.getContext('2d');
              // Draw each canvas onto the merged canvas
              canvasElements.forEach((canvas) => {
                context.drawImage(canvas, 0, 0);
              });
              srcData = mergedCanvas.toDataURL('image/jpeg');
            }
            // Restore the original map size, view resolution, and layer visibility
            refMap.setSize(originalSize);
            refMap.getView().setResolution(originalResolution);
            mapLayers.forEach(layer => layer.setVisible(true));
            resolve(srcData);
          });
          // Trigger a render to fire the 'rendercomplete' event
          refMap.render();
        });
      
        // Set the new print size and resolution
        refMap.setSize([width, height]);
        refMap.getView().setResolution(scaleResolution);
      
        
      
        // Force a synchronous render after adjusting the view
        refMap.renderSync();
      
        return promise;
      }
      
      
      
    getCode(entity, doctype){
            const insee = (MainStore.getState().FormsReducer.formData)?MainStore.getState().FormsReducer.formData.parcelles.data[0]?.insee??'00000':'00000';
            let entityId = MainStore.getState().MeReducer.entity.id;
            let promise = new Promise(resolve => {
                //console.log(entityId, doctype);
                axios.post('/Api/Form_ref/doccode', {"entity_id":entityId, "doctype": doctype, "insee":insee})
                    .then(result=>{
                        let code = (result && result.data)?result.data:"00000";
                        resolve(code);
                    }).catch((e)=>{
                        resolve(code+"00000");
                })
            })
            return promise;
    }

    getAddressBien(){
        let addressBien = MainStore.getState().FormsReducer.addressBien;
        return addressBien;
    }

    getEntityformRef(){
        let formRef = {
        }
    }

    getEntityAnnexes(){
        let userAnnexesService = new UserAnnexesService()
        let defaultAnnexes = userAnnexesService.getdefaultAnnexes()
        let annexes =   MainStore.getState().MeReducer?.entity?.header_form_ref?.header_option;
        return (annexes)?JSON.parse(annexes):defaultAnnexes;
    }
    getEntityHeadingInfo(){
        let headerOptions = MainStore.getState().MeReducer?.entity?.header_form_ref;
        return (headerOptions)?
            {
                header_name:        (headerOptions?.header_name && headerOptions?.header_name!=='')?headerOptions.header_name:null,
                header_address:     (headerOptions?.header_address && headerOptions?.header_address!=='')?headerOptions.header_address:null,
                header_city:        (headerOptions?.header_city && headerOptions?.header_city!=='')?headerOptions.header_city:null,
                header_cp:          (headerOptions?.header_cp && headerOptions?.header_cp!=='')?headerOptions.header_cp:null,
                header_email:       (headerOptions?.header_email && headerOptions?.header_email!=='')?headerOptions.header_email:null,
                header_phone:       (headerOptions?.header_phone && headerOptions?.header_phone!=='')?headerOptions.header_phone:null,
                header_desciption: (headerOptions?.header_desciption && headerOptions?.header_desciption!=='')?headerOptions.header_desciption:null,
                header_code:        (headerOptions?.header_code && headerOptions?.header_code!=='')?headerOptions.header_code:null,
                sign_add:           (headerOptions?.sign_add && headerOptions?.sign_add!=='')?headerOptions.sign_add:null,
                sign_text:          (headerOptions?.sign_text && headerOptions?.sign_text!=='')?headerOptions.sign_text:null,
            }
            :null
    }

    getDemandeurInfo(){
        let demInfo =  MainStore.getState().FormsReducer?.demandeur;
        //console.log(demInfo);
        return demInfo;
    }

}

export default FormsService
